<!-- 个人中心菜单母版 -->
<template>
	<div class="container personal-container">
		<el-container>
			<el-aside width="150px">
				<el-menu v-if="activeMenu" :default-active="activeMenu" :router="true">
					<el-menu-item index="tradelist">
						<span slot="title" class="personal-menu-label" :title="$t('mine.PersonalLayout.718916-0')">{{ $t('mine.PersonalLayout.718916-0') }}</span>
					</el-menu-item>
					<el-menu-item index="tradelistomni">
						<span slot="title" class="personal-menu-label" :title="$t('mine.PersonalLayout.718916-1')">{{ $t('mine.PersonalLayout.718916-1') }}</span>
					</el-menu-item>
					<el-menu-item index="addresslist">
						<span slot="title" class="personal-menu-label" :title="$t('mine.PersonalLayout.718916-2')">{{ $t('mine.PersonalLayout.718916-2') }}</span>
					</el-menu-item>
					<el-menu-item index="collectlist">
						<span slot="title" class="personal-menu-label" :title="$t('mine.PersonalLayout.718916-3')">{{ $t('mine.PersonalLayout.718916-3') }}</span>
					</el-menu-item>
					<el-menu-item index="contactservice">
						<span slot="title" class="personal-menu-label" :title="$t('mine.PersonalLayout.718916-4')">{{ $t('mine.PersonalLayout.718916-4') }}</span>
					</el-menu-item>
				</el-menu>
			</el-aside>
			<el-main>
				<div class="personal-main">
					<slot></slot>
				</div>
				<slot name="personalFooter"></slot>
			</el-main>
			 
		</el-container>
		
	</div>
</template>

<script>
	export default {
		name: 'personal-layout',
		props: {
			curMenu: {
				type: String,
				default: "tradelist"
			} // 当前选中菜单，默认第一个
		},		
		data(){
			return {
				activeMenu: this.curMenu,
			}
		},
		activated(){			
			this.activeMenu = this.curMenu;			
		},
		deactivated(){
			this.activeMenu = undefined; // 设置为undefined重新渲染界面
		}
	}
</script>

<style scoped="scoped">
	.personal-container {
		margin-top: 20px;
	}

	.personal-menu {
		margin: 20px 0;
	}

	.personal-main {
		background-color: #fff;
		height: calc(100vh - 110px);
		overflow: hidden;
		overflow-y: scroll;
	}

	.personal-main::-webkit-scrollbar {
		display: none;
	}

	.el-aside {
		margin-right: 20px;
	}

	.el-menu {
		border: none;
	}

	.el-menu-item {
		padding: 0 16px !important;
	}

	.personal-menu-label {
		display: block;
		overflow: hidden;
		text-align: center;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
</style>
